<ion-toolbar class="header transparent">
	<ion-grid>
		<ion-row class="header-row ion-align-items-start">
			<ion-col class="header-left" size="6">
				<img alt="Topgolf Logo" class="header-logo" src="../../../assets/topgolf/header_logo.svg" />
				@if (venue) {
				<span class="address"> {{venue.name}}, {{venue.street}} {{venue.number}}, {{venue.postalCode}} {{venue.city.de }} </span>
				}
			</ion-col>

			<ion-col class="header-center" size="2"></ion-col>

			<ion-col class="header-right" size="4">
				<!-- <ion-icon (click)="selectLanguageModal()" [src]="'../../../assets/lang/' + translate.getCurrentLang()+ '.svg'" class="lang-icon"></ion-icon> -->
				<app-burger-btn [applyAbsolutePosition]="true"></app-burger-btn>
			</ion-col>
		</ion-row>
	</ion-grid>
	<div class="version">{{ version }}</div>
</ion-toolbar>

<ion-content>
	<div class="wrapper">
		<ion-row class="logo-row ion-justify-content-center ion-align-items-center">
			<ion-icon alt="Logo" class="brand-logo" src="../../../assets/topgolf/full_logo.svg"></ion-icon>
		</ion-row>

		<div class="card">
			@if (tableNumber && table && venue) {
			<p class="table">{{table.description.de}}</p>
			<div class="button">
				<ion-button (click)="goToMenu()">
					@if (loading) {
					<div class="ion-justify-content-center block-width">
						<ion-spinner name="crescent"></ion-spinner>
					</div>
					} @if (!loading) {
					<div class="button-inner">
						<div class="left-block">
							<ion-icon class="burger" src="../../../assets/icon/bell.svg"></ion-icon>
							<p class="button-text">{{ 'home_page.button' | translate }}</p>
						</div>
					</div>
					}
				</ion-button>
			</div>
			} @else if (tableNumber) {
			<div class="ion-justify-content-center block-width">
				<ion-spinner name="crescent"></ion-spinner>
			</div>
			} @if (checksResponse?.checks?.length && !loading && venue.paymentEnabled) {
			<ion-button expand="block" class="button-with-chips ion-margin-top" [href]="getPaymentUrl()">
				<ion-icon name="card" slot="start"></ion-icon>
				{{ 'home_page.pay' | translate }}
			</ion-button>
			}
		</div>
	</div>
</ion-content>
<ion-footer class="ion-padding">
	<p class="home-hint ion-padding ion-text-center">
		<b>{{ 'home_page.notice_label' | translate }}</b> {{ 'home_page.voucher_notice' | translate }}
	</p>
</ion-footer>
